import React, { useEffect, useRef, useState } from 'react'
import Header from './Header'
import axios from 'axios'
import { API } from './constant'
import { FaWheatAwnCircleExclamation } from 'react-icons/fa6'
import { UNSAFE_useScrollRestoration } from 'react-router-dom'

import { IoMdClose } from "react-icons/io";
// import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material'


// material ui components start 
// import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';


const AddParagraph = () => {

  const [updateTable, setupdateTable] = useState(false)


  const [paragraph_name, setparagraph_name] = useState("")
  const [lexile_score, setlexile_score] = useState("")
  const [approx_word_count, setapprox_word_count] = useState("")
  const [student_age, setstudent_age] = useState([])
  const [student_grade, setstudent_grade] = useState([])
  const [paragraphType, setparagraphType] = useState("")
  const [paragraph_details, setparagraph_details] = useState("")

  const [paragraphName, setparagraphName] = useState([])



  const [TotalparagraphName, setTotalparagraphName] = useState([])

  const handleSubmitParagraph = async () => {
    const data = {
      paragraph_name: paragraph_name,
      lexile_score: lexile_score,
      approx_word_count: approx_word_count,
      student_age: student_age,
      student_grade: student_grade,
      paragraph_details: paragraph_details,
      paragraphType: paragraphType
    }
    await axios.post(`${API}/add-paragraph`, data, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res)
        alert(res.data.message)
        clearfields()
        setupdateTable(!updateTable)
      })
      .catch((error) => {
        console.log(error)
        alert(error.response.data.message)
      })
  }

  useEffect(() => {
    // axios.get(`${API}/add-paragraph/`, {
    axios.get(`${API}/add-paragraph/paragraphs-by-location`, {
      headers: {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data.data)
        setparagraphName(res.data.data)

        const total = res.data.data.length;
        setTotalparagraphName(total)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])



  const [fields, setFields] = useState([{ sentence: '', wordCount: 0, cumulativeWordCount: 0 }]);

  const handleInputChange = (index, event) => {
    const { value } = event.target;
    const updatedFields = [...fields];

    // Update the current field
    updatedFields[index] = {
      sentence: value,
      wordCount: value.trim().split(/\s+/).length,
      cumulativeWordCount: index === 0 ? value.trim().split(/\s+/).length : updatedFields[index - 1].cumulativeWordCount + value.trim().split(/\s+/).length
    };

    // Update subsequent fields' cumulative word count
    for (let i = index + 1; i < updatedFields.length; i++) {
      updatedFields[i] = {
        ...updatedFields[i],
        cumulativeWordCount: updatedFields[i - 1].cumulativeWordCount + updatedFields[i].wordCount
      };
    }

    setFields(updatedFields);
  };


  const handleAddField = () => {
    setFields([...fields, { sentence: '', wordCount: 0, cumulativeWordCount: fields.length > 0 ? fields[fields.length - 1].cumulativeWordCount : 0 }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = [...fields];
    updatedFields.splice(index, 1);
    setFields(updatedFields);
  };



  //============= ============find user role and give permission start ============================
  const [loggedinRole, setLoggedinRole] = useState("")
  useEffect(() => {
    axios.get(`${API}/login/logged-in-user`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        setLoggedinRole(res.data.data.role)
      })
      .catch((err) => {
        // console.log(err);
        if (err.response) {
          // Handle invalid token
          if (err.response.status === 401) {
            localStorage.removeItem("token");
            // history.push('/');
            window.location.href = "/"
          }
          // Handle token expiration
          else if (err.response.status === 302) {
            window.location.href = "/"

          }
        }
      });
  }, [])

  //============= ============find user role and give permission end ============================





  // =======================show student age in dropdown menu start =======================================

  //------- get all student age start -----------
  const [getAllStudetnAge, setgetAllStudetnAge] = useState([])
  // console.log(getAllStudetnAge)
  useEffect(() => {
    axios.get(`${API}/student-age`)
      .then((res) => {
        // console.log(res.data.data)
        setgetAllStudetnAge(res.data.data)

      }).catch((err) => {
        console.log(err)
      })
  }, [])
  //------- get all student age end -----------

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setstudent_age(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeGrade = (event) => {
    const {
      target: { value },
    } = event;
    setstudent_grade(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  // =======================show student age in dropdown menu end =======================================



  //================================== add question to the dynamic lexile score start ========================================
  const [selectedParagraph, setselectedParagraph] = useState("")
  const [questionName, setquestionName] = useState("")
  const [answerForQuestion, setanswerForQuestion] = useState("")
  const [Student_answer, setStudent_answer] = useState("")

  const submitQuestion = async () => {
    const data = {
      paragraph_id: selectedParagraph,
      question_name: questionName,
      answer_for_question: answerForQuestion,
    }
    await axios.post(`${API}/question`, data)
      .then((res) => {
        console.log(res)
        alert(res.data.message)
        setupdateTable(!updateTable)
        clearfields()

      })
      .catch((err) => {
        console.log(err)
        alert(err.response.data.message)

      })
  }


  // ------------get all question start -----------------
  const [get_allQuestion, setget_allQuestion] = useState([])
  useEffect(() => {
    axios.get(`${API}/question`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then((res) => {
        // console.log(res.data.data)
        setget_allQuestion(res.data.data)
      })
      .catch((err) => {
        console.log(err)
        alert(err.response.data.message)
      })
  }, [updateTable])
  // ------------get all question end -----------------

  //------------------ handle edit questionn start ------------
  const [QuestionEditModal, setQuestionEditModal] = useState(false)
  const [QuestionEditModalID, setQuestionEditModalID] = useState("")

  const [editquestionName, seteditquestionName] = useState("")
  const [editanswerForQuestion, seteditanswerForQuestion] = useState("")


  const handleEditQuestion = async (id) => {
    setQuestionEditModal(true)
    setQuestionEditModalID(id)
    await axios.get(`${API}/question/${id}`)
      .then((res) => {
        console.log(res)
        seteditquestionName(res.data.data.question_name)
        seteditanswerForQuestion(res.data.data.answer_for_question)
      })
      .catch((err) => {
        console.log(err)
      })
  }


  const hadleEditSubmit = async (id) => {
    const data = {
      question_name: editquestionName,
      answer_for_question: editanswerForQuestion,
      student_answer: Student_answer
    }

    await axios.put(`${API}/question/${id}`, data)
      .then((res) => {
        // console.log(res)
        alert(res.data.message)
        setQuestionEditModal(false)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        console.log(err)
        alert(err.response.data.message)
      })
  }
  //------------------ handle edit questionn end ------------


  // ---------------handle delete question start ----------------
  const [deletePopUp, setdeletePopUp] = useState(false)
  const [deletePopUpID, setdeletePopUpID] = useState(false)

  const handleDeletePop = (id) => {
    setdeletePopUp(true)
    setdeletePopUpID(id)
  }

  const deleteQuestion = async (id) => {
    await axios.delete(`${API}/question/${id}`)
      .then((res) => {
        console.log(res)
        alert(res.data.message)
        setdeletePopUp(false)
        setupdateTable(!updateTable)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  // ---------------handle delete question end ----------------

  //================================== add question to the dynamic lexile score end ========================================

  // ====================================get class data start ================================================

  // --------------get all class data start ----------
  const [allClassDATA, setallClassDATA] = useState([])
  useEffect(() => {
    axios.get(`${API}/create-class`)
      .then((res) => {
        // console.log(res)
        setallClassDATA(res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [updateTable])
  // ------------get all class data end------------
  // ====================================get class data end ================================================


  // clear fields  start 
  const clearfields = () => {
    setparagraph_details("")
    setstudent_grade([])
    setstudent_age([])
    setparagraphType("")
    setapprox_word_count("")
    setlexile_score("")
    setparagraph_name("")
    setquestionName("")
    setanswerForQuestion("")
    seteditquestionName("")
    seteditanswerForQuestion("")

  }
  // clear fields  end


  // change over select start 
  const [sentence_questions, setsentence_questions] = useState("input_sentence")
  // change over select end

  // --------print functionality start -------------
  const printRef = useRef();
  // const handlePrint = () => {
  //   const printContents = printRef.current.innerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  //   window.location.reload();
  // };
  const handlePrint = (index) => {
    const printContents = document.getElementById(`printable-${index}`).innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print</title>');
    printWindow.document.write('<style>@media print { body * { visibility: hidden; } .printable, .printable * { visibility: visible; } .printable { position: absolute; left: 0; top: 0; }}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(`<div class="printable">${printContents}</div>`);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  // const handlePrint = () => {
  //   const printContents = printRef.current.innerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  //   window.location.reload();
  // };


  // --------print functionality end -------------


  //---------- search functionality start --------------
  const [searchParagraph, setsearchParagraph] = useState("")
  const [searchLexile, setsearchLexile] = useState("")
  const [filteredData, setfilteredData] = useState(paragraphName)


  // search paragraph start 
  const handleChangeSearchParagraph = (event) => {
    const {
      target: { value },
    } = event;
    setsearchParagraph(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // search paragraph end

  useEffect(() => {
    // const handler = setTimeout(() => {
    //   if (searchLexile === "") {
    //     setfilteredData(paragraphName)
    //   } else {
    //     const filtered = paragraphName.filter((data) =>
    //       data.lexile_score.toLowerCase().includes(searchLexile.toLowerCase())
    //     )
    //     setfilteredData(filtered)
    //   }
    const handler = setTimeout(() => {
      if (searchLexile === "") {
        setfilteredData(paragraphName);
      } else {
        // Check if the search input contains a range
        const rangeMatch = searchLexile.match(/^(\d+)-(\d+)$/);
        if (rangeMatch) {
          const [min, max] = rangeMatch.slice(1).map(Number);
          const filtered = paragraphName.filter(data => {
            const lexileScore = parseInt(data.lexile_score, 10);
            return lexileScore >= min && lexileScore <= max;
          });
          setfilteredData(filtered);
        } else {
          const filtered = paragraphName.filter(data =>
            data.lexile_score.toLowerCase().includes(searchLexile.toLowerCase())
          );
          setfilteredData(filtered);
        }
      }
    }, 500);

    // cleanup timeout if searchLexile changes before delay is over 
    return () => {
      clearTimeout(handler)
    }

  }, [searchLexile, paragraphName])




  //---------- search functionality end --------------




  return (
    <div>
      {
        loggedinRole && loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (

          <div className=''>
            <Header />
            <div className='flex justify-center mt-[70px] sm:mt-[150px]'>
              <div className='max-w-[1500px] w-full  ' >
                {/* paragraph, lexile score, approx word count start  */}

                {
                  loggedinRole === "Super Admin" ? (
                    <>
                      <div className='my-[20px] flex justify-between flex-wrap p-[3px]'>
                        <div className='w-[100%] sm:w-[35%]'>
                          <div>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Paragraph Name:</label>
                          </div>
                          <div className='text-[12px] sm:text-[15px] w-[100%] sm:w-[80%]' >
                            <input value={paragraph_name} onChange={(e) => setparagraph_name(e.target.value)} className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Paragraph Name' />
                          </div>
                          </div>
                        </div>

                        <div className='w-[45%] sm:w-[18%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Paragraph Type:</label>
                          </div>
                          <div className='w-[100%]' >
                            <select value={paragraphType} onChange={(e) => setparagraphType(e.target.value)} className='text-[12px] sm:text-[15px] w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' >
                              <option value="">select Paragraph type</option>
                              <option value="FICTION">FICTION</option>
                              <option value="NON-FICTION">NON-FICTION</option>
                              <option value="GENERAL">GENERAL</option>
                            </select>
                          </div>
                        </div>


                        <div className='w-[45%] sm:w-[18%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Lexile Score:</label>
                          </div>
                          <div className='w-[100%]' >
                            <input value={lexile_score} onChange={(e) => setlexile_score(e.target.value)} className='text-[12px] sm:text-[15px] w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="number" placeholder='Lexile Score' />
                          </div>
                        </div>

                        <div className='w-[45%] sm:w-[18%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Approx word Count:</label>
                          </div>
                          <div className='w-[100%]'>
                            <input value={approx_word_count} onChange={(e) => setapprox_word_count(e.target.value)} className='text-[12px] sm:text-[15px] w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Approx word Count' />
                          </div>
                        </div>
                      </div>

                      <div className='my-[20px] w-[100%] sm:w-[50%] flex justify-between p-[3px]'>

                        <div className='w-[45%] sm:w-[50%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Student Age:</label>
                          </div>
                          <div className='w-[100%] sm:w-[90%] ' >
                            {/* <input value={student_age} onChange={(e) => setstudent_age(e.target.value)} className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Student Age' /> */}
                            {/* <select value={student_age} onChange={(e) => setstudent_age(e.target.value)} className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
                        <option value="">Select student age</option>
                        {
                          getAllStudetnAge && getAllStudetnAge.map((item, index) => {
                            return (
                              <option key={index} value={item.name}>{item.name}</option>
                            )
                          })
                        }

                      </select> */}

                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              style={{ color: "white" }}
                              className='rounded-md bg-black/80  sm:w-full outline-none MuiSelect-select w-[100%]'
                              multiple
                              value={student_age}
                              onChange={handleChange}
                              placeholder='Select age'
                              // onChange={handleSearchSection}
                              // input={<OutlinedInput  label="Select Section" />}
                              renderValue={(selected) => selected.join(',')}
                            // MenuProps={MenuProps}
                            >
                              {getAllStudetnAge && getAllStudetnAge.map((name, index) => (

                                <MenuItem selected className="MenuItem " key={name._id} value={name.name}>
                                  <Checkbox checked={student_age.indexOf(name.name) > -1} />
                                  <ListItemText primary={name.name} />
                                </MenuItem>

                              ))}
                            </Select>


                          </div>
                        </div>

                        <div className='w-[45%] sm:w-[50%]'>
                          <div className=''>
                            <label className='text-[12px] sm:text-[18px] ' htmlFor="">Student Grade:</label>
                            {/* <InputLabel id="demo-simple-select-label">Student Grade:</InputLabel> */}
                          </div>
                          <div className='w-[100%] sm:w-[90%]' >
                            {/* <input value={student_grade} onChange={(e) => setstudent_grade(e.target.value)} className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md' type="text" placeholder='Enter Student Grade' /> */}
                            {/* <select value={student_grade} onChange={(e) => setstudent_grade(e.target.value)} className='w-full bg-black/80 text-white py-[10px] px-[10px] outline-none rounded-md'>
                        <option value="">Select student Grade</option>
                        {
                          allClassDATA && allClassDATA.map((item, index) => {
                            return (
                              <option key={index} value={item.name}>{item.name}</option>
                            )
                          })
                        }

                      </select> */}

                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-multiple-checkbox"
                              style={{ color: "white" }}
                              className='rounded-md bg-black/80  w-full outline-none MuiSelect-select '
                              multiple
                              value={student_grade}
                              onChange={handleChangeGrade}
                              placeholder='Select Section'
                              label="Appropriate Classes"
                              // onChange={handleSearchSection}
                              // input={<OutlinedInput  label="Select appropriate classes" />}
                              renderValue={(selected) => selected.join(',')}
                              // MenuProps={MenuProps}
                              variant='outlined'
                            >
                              {allClassDATA && allClassDATA.map((name, index) => (

                                <MenuItem selected className="MenuItem" key={name._id} value={name.name}>
                                  <Checkbox checked={student_grade.indexOf(name.name) > -1} />
                                  <ListItemText primary={name.name} />
                                </MenuItem>

                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      {/* paragraph, lexile score, approx word count end  */}

                      {/* Enter paragraph start  */}
                      <div className='p-[3px]'>
                        <textarea value={paragraph_details} onChange={(e) => setparagraph_details(e.target.value)} className='text-[12px] sm:text-[15px] w-full bg-black/80 text-white outline-none px-[10px] py-[8px] resize-none' rows={13} placeholder='Enter Your Paragraph Here...' >

                        </textarea>
                      </div>
                      {/* Enter paragraph end */}

                      {/* Add details button start  */}
                      <div className='flex justify-center items-center mt-[20px] rounded-md'>
                        <button onClick={() => handleSubmitParagraph()} className='text-[12px] sm:text-[15px] bg-[#1B1B1B] hover:bg-[#8321A8] px-[20px] py-[5px] text-white font-semibold rounded-md'>Submit</button>
                      </div>
                      {/* Add details button end */}

                    </>
                  ) : null
                }

                {/* Map Your Lexile here start  */}
                {/* <div className='my-[30px]'>
              <h2 className='text-[30px] font-medium text-[#374CC3]'>Map Your Lexile Here!!</h2>
              <div className=' w-[80%] flex justify-start items-center mt-[10px]'>
                <div className='px-[10px] py-[3px] bg-black/80 w-[50px] border-[1px] border-white text-white '>Row</div>
                <div className='px-[10px] py-[3px] bg-black/80 w-[500px] border-[1px] border-white text-white'>
                  Paragraph Name:
                  <select className='bg-black/80 outline-none'>
                    <option value="">Select Your Paragraph</option>
                    {
                      paragraphName && paragraphName.map((item, index) => {
                        return (
                          <option key={index} value={item.paragraph_name}>{item.paragraph_name}</option>
                        )
                      })

                    }
                  </select>
                </div>
                <div className='px-[10px] py-[3px] bg-black/80 w-[200px] border-[1px] border-white text-white'>Number Of Words</div>
                <div className='px-[10px] py-[3px] bg-black/80 w-[200px] border-[1px] border-white text-white'>Cumultive words</div>
              </div>
              <div className=' w-[80%] flex justify-start items-center '>
                <div className='px-[10px] py-[3px] bg-black/80 w-[50px] border-[1px] border-white text-white text-center'>1</div>
                <div className=' bg-black/80 w-[500px] border-[1px] border-white text-white'><input className='w-full outline-none border text-black' placeholder='Enter Your text here...' type="text" /></div>
                <div className='px-[10px] py-[3px] bg-black/80 w-[200px] border-[1px] border-white text-white'>18</div>
                <div className='px-[10px] py-[3px] bg-black/80 w-[200px] border-[1px] border-white text-white'>18</div>
                <div className='px-[10px] py-[3px] bg-green-700 text-center w-[100px] border-[1px] border-white text-white'>Add</div>
              </div>

            </div> */}
                {/* Map Your Lexile here end */}

                {/* paragraphs added over here start  */}
                <div className='my-[30px]'>

                  <h2 className='text-[15px] sm:text-[30px] font-medium text-[#374CC3]'>Paragraph</h2>
                  <p className='text-[10px] sm:text-[18px] font-medium text-[#374CC3]'>Total Paragraphs:{TotalparagraphName}</p>
                  <div className='flex gap-4 items-center mb-1' >
                    <div className='w-[45%] sm:w-[25%]'>
                      <div>
                        <h2 className='text-[12px] sm:text-[15px]'>Search Paragraph:</h2>
                        <select value={searchParagraph} onChange={(e) => setsearchParagraph(e.target.value)} className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white'>
                          <option value="">Select Your Paragraph</option>
                          {
                            paragraphName && paragraphName.map((item, index) => {
                              return (
                                <option key={index} value={item.paragraph_name}>{item.paragraph_name}</option>
                              )
                            })

                          }
                        </select>

                      </div>
                    </div>

                    <div className='w-[45%] sm:w-[25%]'>
                      <div>
                        <h2 className='text-[12px] sm:text-[15px]'>Search Lexile:</h2>

                      </div>
                      <input value={searchLexile} onChange={(e) => setsearchLexile(e.target.value)} type="search" className='text-[12px] sm:text-[15px] bg-black outline-none w-full text-white px-[10px]' placeholder='Search Lexile here' />
                    </div>

                  </div>
                  <div className='border-black border-[1px] p-[5px] h-[70vh] overflow-hidden overflow-y-scroll'>
                    {
                      filteredData && filteredData.filter((item) => {
                        if (searchParagraph === "") {
                          return item
                        } else {
                          return item.paragraph_name === searchParagraph
                        }
                      }).map((item, index) => {
                        return (
                          <div id={`printable-${index}`} ref={printRef} key={index} className='border-[1px] border-black border-collapse my-[5px]'>
                            <div className=' w-[100%]  mt-[10px]'>
                              <div className='flex justify-between'>
                                <h1 className='text-[12px] sm:text-[20px] font-bold'>{item.paragraph_name}</h1>
                                <div className='pr-[20px]'>
                                  <button onClick={() => handlePrint(index)} className='text-[12px] sm:text-[15px] px-[13px] py-[4px] sm:px-[26px] sm:py-[8px] bg-black text-white rounded-md'>Print</button>
                                </div>
                              </div>
                              <div className='flex gap-10'>
                                <div>
                                  {/* <h2 className='text-[12px] sm:text-[15px] font-bold'>Student Age:- <span className='font-thin'>{item.student_age.join(", ")}</span></h2> */}
                                  <h2 className='text-[12px] sm:text-[15px] font-bold'>Student Age:- <span className='font-thin'>{Array.isArray(item.student_age) ? item.student_age.join(", ") : item.student_age}</span></h2>
                                </div>
                                <div>
                                  {/* <h2 className='text-[12px] sm:text-[15px] font-bold'>Grade Level:- <span className='font-thin'>{item.student_grade.join(", ")}</span></h2> */}
                                  <h2 className='text-[12px] sm:text-[15px] font-bold'>Grade Level:- <span className='font-thin'>{Array.isArray(item.student_grade) ? item.student_grade.join(", ") : item.student_grade}</span></h2>
                                </div>
                              </div>
                              <div className='flex gap-10'>
                                <div>
                                  <h2 className='text-[12px] sm:text-[15px] font-bold'>Lexile Level:- <span className='font-thin'>{item.lexile_score}L</span></h2>
                                </div>
                                <div>
                                  <h2 className='text-[12px] sm:text-[15px] font-bold ' >Approx Word:- <span className='font-thin'>{item.approx_word_count}</span></h2>
                                </div>
                                <div>
                                  <h2 className='text-[12px] sm:text-[15px] font-bold ' >Paragraph Type:- <span className='font-thin'>{item.paragraphType}</span></h2>
                                </div>
                              </div>
                              <div className='w-[100%] sm:w-[80%] border-[1px] p-[10px]'>
                                {/* {item.paragraph_details} */}
                                <table className='table-auto w-full'>
                                  <thead>
                                    <tr className="bg-gray-100">
                                      <th className="text-[12px] sm:text-[15px] border px-4 py-2">Serial No.</th>
                                      <th className="text-[12px] sm:text-[15px] border px-4 py-2">Paragraph Content</th>
                                      <th className="text-[12px] sm:text-[15px] border px-4 py-2">Word Count</th>
                                      <th className="text-[12px] sm:text-[15px] border px-4 py-2">Cumulative Word Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {renderTable(item.paragraph_details)}
                                  </tbody>
                                </table>
                              </div>

                            </div>
                          </div>
                        )
                      })
                    }

                  </div>
                </div>
                {/* paragraphs added over here end */}



                {/* dynamic lexile input start  */}

                {/* <div className=" w-full mx-auto my-[30px]">
              <div className=' w-full px-[10px] py-[3px] bg-black/80 border-[1px] border-white text-white flex justify-between'>
                Paragraph Name:
                <div className='w-[40%]'>
                  <select value={selectedParagraph} onChange={(e) => setselectedParagraph(e.target.value)} className='bg-black/80 outline-none w-full'>
                    <option value="">Select Your Paragraph</option>
                    {
                      paragraphName && paragraphName.map((item, index) => {
                        return (
                          <option key={index} value={item._id}>{item.paragraph_name}</option>
                        )
                      })

                    }
                  </select>
                </div>

                <div className='w-[40%]'>
                  <select onChange={(e) => setsentence_questions(e.target.value)} className='bg-black/80 outline-none w-full'>
                    <option value="input_sentence">Input sentence</option>
                    <option value="input_question">Input Questions</option>
                  </select>
                </div>


              </div>
              {
                sentence_questions === "input_sentence" ? (
                  <div>
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border px-4 py-2">Input Sentence</th>
                          <th className="border w-[10%] px-4 py-2">Total Words</th>
                          <th className="border w-[10%]  px-4 py-2">Cumulative Word Count</th>
                          <th className="border w-[15%] px-4 py-2">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((field, index) => (
                          <tr key={index}>
                            <td className="border px-4 py-2">
                              <input
                                type="text"
                                value={field.sentence}
                                onChange={(e) => handleInputChange(index, e)}
                                className="w-full border rounded px-2 py-1"
                              />
                            </td>
                            <td className="border px-4 py-2">{field.wordCount}</td>
                            <td className="border px-4 py-2">{field.cumulativeWordCount}</td>
                            <td className="border px-4 py-2">
                              <button
                                onClick={() => handleRemoveField(index)}
                                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className='flex justify-end'>
                      <button
                        onClick={handleAddField}
                        className='mt-4 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded'
                      >Add Field</button>
                    </div>

                    <div className='flex justify-center'>
                      <button
                        className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                ) :
                  (
                    <div>
                      <table className="w-full">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border px-4 py-2">Quetion Name</th>
                            <th className="border px-4 py-2">Answer for Question</th>
                            <th className="border px-4 py-2">Edit</th>
                            <th className="border px-4 py-2">Delete</th>
                          </tr>
                        </thead>
                        <tbody>

                          {
                            get_allQuestion && get_allQuestion.filter((item) => {
                              if (selectedParagraph === "") {
                                return item
                              } else {
                                console.log(selectedParagraph)
                                return item.paragraph_id._id === `${selectedParagraph}`
                              }
                            }).map((item, index) => {
                              return (
                                <tr key={index} >
                                  <td className="border px-4 py-2">
                                    <input
                                      type="text"
                                      className="w-full border rounded px-2 py-1 outline-none"
                                      readOnly
                                      value={item.question_name}
                                    />
                                  </td>
                                  <td className="border px-4 py-2">
                                    <input
                                      type="text"
                                      className="w-full border rounded px-2 py-1 outline-none"
                                      readOnly
                                      value={item.answer_for_question}
                                    />
                                  </td>
                                  <td className="border px-4 py-2 w-[10%]">
                                    <button onClick={() => handleEditQuestion(item._id)}>Edit</button>
                                  </td>
                                  <td className="border px-4 py-2 w-[10%]">
                                    <button onClick={() => handleDeletePop(item._id)}>Delete</button>
                                  </td>
                                </tr>
                              )
                            })
                          }

                          <tr >
                            <td className="border px-4 py-2 w-[40%]">
                              <input
                                type="text"
                                className="w-full border rounded px-2 py-1 outline-none"
                                onChange={(e) => setquestionName(e.target.value)}
                                value={questionName}
                              />
                            </td>
                            <td className="border px-4 py-2 w-[40%]">
                              <input
                                type="text"
                                className="w-full border rounded px-2 py-1 outline-none"
                                onChange={(e) => setanswerForQuestion(e.target.value)}
                                value={answerForQuestion}
                              />
                            </td>
                            <td className="border px-4 py-2">
                              <button
                                className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                                onClick={() => submitQuestion()}
                              >
                                Submit
                              </button>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                   
                    </div>


                  )
              }

            </div>


            {
              QuestionEditModal && QuestionEditModal ? (
                <div>
                  <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                    <div className='w-[80%]'>
                      <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Question</h5> <button onClick={() => setQuestionEditModal(false)}><IoMdClose size={30} color='white' /></button></div>
                   
                      <div className='bg-white py-[10px]'>
                        <table className="w-full bg-white">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border px-4 py-2">Quetion Name</th>
                              <th className="border px-4 py-2">Answer for Question</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr >
                              <td className="border px-4 py-2 w-[40%]">
                                <input
                                  type="text"
                                  className="w-full border rounded px-2 py-1 outline-none"
                                  onChange={(e) => seteditquestionName(e.target.value)}
                                  value={editquestionName}
                                />
                              </td>
                              <td className="border px-4 py-2 w-[40%]">
                                <input
                                  type="text"
                                  className="w-full border rounded px-2 py-1 outline-none"
                                  onChange={(e) => seteditanswerForQuestion(e.target.value)}
                                  value={editanswerForQuestion}
                                />
                              </td>
                            </tr>


                          </tbody>

                        </table>


                        <div className='flex justify-center'>
                          <button
                            className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                            onClick={() => hadleEditSubmit(QuestionEditModalID)}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                 
                    </div>
                  </div>
                </div>
              ) : null
            }


            {
              deletePopUp && deletePopUp ? (
                <div>
                  <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                    <div className='w-[300px] bg-black rounded-md py-[20px]'>
                      <div>
                        <h4 className='text-[12px] text-white font-semibold text-center'>Would you like to delete?</h4>
                      </div>



                      <div className='flex gap-6 justify-center my-[10px]'>
                      
                        <button onClick={() => deleteQuestion(deletePopUpID)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                        <button onClick={() => handleDeletePop(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                      </div>
                    </div>
                    
                  </div>
                </div>
              ) : null


            } */}

                {/* dynamic lexile input end */}

              </div>
            </div>
          </div>
        ) : (
          <>
            <p>You are not Authorized</p>
          </>
        )
      }
    </div>
  )
}


const renderTable = (paragraphDetails) => {
  const lines = paragraphDetails.split('*').filter(line => line.trim() !== "");
  let cumulativeWordCount = 0;

  return lines.map((line, index) => {
    const words = line.trim().split(' ');
    const wordCount = words.length;
    cumulativeWordCount += wordCount;

    return (
      <tr key={index} className='hover:bg-[#6c7ae0]/40'>
        <td className="text-[12px] sm:text-[15px] border px-4 py-2">{index + 1}</td>
        <td className="text-[12px] sm:text-[15px] border px-4 py-2">{line}</td>
        <td className="text-[12px] sm:text-[15px] border px-4 py-2">{wordCount}</td>
        <td className="text-[12px] sm:text-[15px] border px-4 py-2">{cumulativeWordCount}</td>
      </tr>
    );
  });

};


export default AddParagraph